module.exports = __webpack_public_path__ + "img/loading.f42004eb.gif";